export const TYPES = {
  default: 'default',
  light: 'light',
  white: 'white',
  accent: 'accent',
  cta: 'cta',
  success: 'success',
  error: 'error',
  warning: 'warning',
  inherit: 'inherit',
};
